/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

import Dashboard from "layouts/dashboard";
import TruckerCompany from "layouts/admin/truckerCompany";
import Appointment from "layouts/appointment";
import SignIn from "layouts/authentication/sign-in";
// @mui icons
import Icon from "@mui/material/Icon";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import EirHistory from 'layouts/eirHistory';
import Truckers from "layouts/truckers";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import Users from "layouts/admin/users";
import ResetPassword from "layouts/authentication/reset-password/ResetPassword";
const routes = [
  {
    type: 'collapse',
    name: 'Dashboard',
    key: 'Dashboard',
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: '/dashboard',
    component: <Dashboard />
  },

  {
    type: 'collapse',
    name: 'users_truckers',
    key: 'users_truckers',
    icon: <Icon fontSize="small">groups</Icon>,
    route: '/management',
    component: <Truckers />
  },
  {
    type: 'collapse',
    name: 'Eir_history',
    key: 'Eir_history',
    icon: <Icon fontSize="small">description</Icon>,
    route: '/EirHisto',
    component: <EirHistory />
  },
  {
    type: 'collapse',
    name: 'Appointments',
    key: 'Appointments',
    icon: <Icon fontSize="small">calendar_month</Icon>,
    route: '/appointment',
    component: <Appointment />
  },
  {
    key: 'sign-in',
    route: '/authentication/sign-in',
    component: <SignIn />
  },
  {
    key: 'reset-password',
    route: '/reset-password',
    component: <ResetPassword />
  }
];
export const adminRoutes = [
  {
    type: "collapse",
    name: "companies_ft",
    key: "Trucker companies",
    icon: <LocalShippingIcon fontSize="small"></LocalShippingIcon>,
    route: "/truck-companies",
    component: <TruckerCompany />,
  },
  {
    type: "collapse",
    name: "users_ft",
    key: "users_ft",
    icon: <SupervisedUserCircleIcon fontSize="small"></SupervisedUserCircleIcon>,
    route: "/users",
    component: <Users />,
  },
  {
    key: "sign-in",
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
];
export default routes;
